<div class="td-wb-steps__header">
  <h2 class="td-wb-vh"
      [innerText]="'tdWb.steps.TOTAL_STEPS' | tdWbTranslate: { totalSteps: getStepsCount() }">
  </h2>
</div>
<div class="td-wb-steps__content">
  <ng-content select="td-wb-step" />
</div>
